export const integrationhelper_index = ['integrationhelper.index']
export const integrationhelper_create = ['integrationhelper.create']
export const integrationhelper_edit = ['integrationhelper.edit']

export default [].concat(
    integrationhelper_index,
    integrationhelper_create,
    integrationhelper_edit
)
